import type { ConfigRouteParamsRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-client';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type EventInviteesPathRequestParams = paths['/v3/event_users/{id}']['get']['parameters']['path'];
type EventInviteesQueryRequestParams = paths['/v3/event_users/{id}']['get']['parameters']['query'];
type ResponseType = paths['/v3/event_users/{id}']['get']['responses']['200']['content']['application/json'];

export const getEventInvitees = async ({
  config: { params },
  routeParams: { id },
}: ConfigRouteParamsRequest<EventInviteesQueryRequestParams, EventInviteesPathRequestParams>) =>
  apiClient.get<ResponseType, ApiClientResponse<ResponseType>>(routes.events.users(id), { params });
